(function() {


    class Wishlist {
        constructor() {
            console.log('CTWF Wishlist Activated');

            this.items = [];
            this.product_cache = {};
            this.$selectors = {
                btns: '.wishlist-btn'
            };

            // Binds
            this.btnClickHandler = this.btnClickHandler.bind(this);
            this.getWishlistModel = this.getWishlistModel.bind(this);
            this.swymInitialCallback = this.swymInitialCallback.bind(this);
            this.prepWishlistPage = this.prepWishlistPage.bind(this);

            this.start();
        }

        getSwat() {
            return this.swat || window._swat;
        }

        getWishlistItems() { 
            return new Promise((resolve, reject) => { 
                window._swat.fetch(function(r) { 
                    console.log('Wishlist Items', r);
                    if(!r) reject(r);
                    resolve(r);
                });
            })
        }

        getWishlistModel(handle) {
            if(this.product_cache[handle]) return this.product_cache[handle];

            return fetch(`/products/${handle}?view=wishlist`).then((r) => r.json()).then((r) => {
                this.product_cache[handle] = r;
                return r;
            }).catch(() => { return {} });
        }

        async getWishlistItemByHandle(handle) {
           const item = (window.SwymProductInfo.product && window.SwymProductInfo.product.handle === handle) ? window.SwymPageData : await this.getWishlistModel(handle);

           return item;
        }

        async swymInitialCallback(swat) {
            this.swat = swat;

            const items = await this.getWishlistItems();

            this.items = [...items];

            if(/my-wishlist/.test(location.pathname)) {
                this.prepWishlistPage();
            }

            [...this.items].forEach(({ du }) => {
                const handle = du.split('/').reverse()[0];

                const $btns = document.querySelectorAll(`.wishlist-btn[data-product="${handle}"]`);

                console.log('Wishlist Item', { handle, $btns });

                [...$btns].forEach(($btn) => {
                    const isIcon = $btn.classList.contains('icon-wishlist');

                    if(isIcon) {
                        this.updateIconBtn($btn, true);
                    } else {
                        this.updateTextBtn($btn, true);
                    }
                });

            });

            this.attachHandlers();
        }

        async addItemToList(item) {
            let swat = this.getSwat();

            return new Promise((resolve, reject) => {
                swat.addToWishList(
                    { ...item },
                    function(r) {
                        console.log('Item added', r);
                        if(!r) reject(r);
                        resolve(r);
                    }
                );
            });            
        }

        async removeItemFromList(item) {
            let swat = this.getSwat();

            return new Promise((resolve, reject) => {
                swat.removeFromWishList(
                    {...item},
                    function(r) {
                        if(!r) reject(r);
                        resolve(r);
                    }
                  );
            });
        }

        updateTextBtn(target, add) {

            if(add) {                
                target.textContent = 'REMOVE FROM WISHLIST';
                target.setAttribute('data-action', 'remove');
            } else {
                target.textContent = 'ADD TO WISHLIST';
                target.setAttribute('data-action', 'add');
            }
        }

        updateIconBtn(target, add) {
            if(add) {
                target.setAttribute('data-action', 'remove');
                target.classList.add('filled-icon');
            } else {
                target.setAttribute('data-action', 'add');
                target.classList.remove('filled-icon');
            }

        }

        loaderIcon() {
            const $rhombus = document.createElement('span');

            $rhombus.classList.add('loader');


            return $rhombus;
        }

        toggleLoadingIcon($btn, add) {
            if(add) {
                const $loader = this.loaderIcon();
    
                $btn.classList.add('loading');
                $btn.appendChild($loader);
            } else {
                let $loader = $btn.querySelector('.loader');

                $btn.removeChild($loader);
                $btn.classList.remove('loading');
            }
        }


        async btnClickHandler(event) {
            event.preventDefault();

            const { target } = event;
            const productHandle = target.dataset.product;
            const item = await this.getWishlistItemByHandle(productHandle);
            const add = (target.dataset.action === 'add');
            const isIcon = target.classList.contains('icon-wishlist');

            console.log('Click Handler', { add, item, isIcon });
            // this.toggleLoadingIcon(target, true);

            const response = (add) ? await this.addItemToList(item) : await this.removeItemFromList(item);

            if(isIcon) {
                this.updateIconBtn(target, add);
            } else {
                this.updateTextBtn(target, add);
            }
            
            // setTimeout(() => {
            //     this.toggleLoadingIcon(target, false);
            // }, 500);
            console.log('Wishlist btn', response);
        }

        attachHandlers() {
            const $btns = document.querySelectorAll(this.$selectors.btns);

            [...$btns].forEach(($btn) => $btn.addEventListener('click', this.btnClickHandler));
        }

        start() {
            if(!window.SwymCallbacks) {
                window.SwymCallbacks = [];
            }

            if(!window.SwymProducts) {
                window.SwymProducts = [];
            }

            window.SwymCallbacks.push(this.swymInitialCallback);
        }

        getWishlistPageItems() { 
            let swat = this.getSwat();

            return new Promise((resolve, reject) => { 
                swat.fetch(function(r) {
                    if(!r) reject(r);
                    resolve(r);
                });
            })
        }

        wishlistItemHTML({
            dt,
            du,
            iu,
        }) {
            const handle = du.split('/').reverse()[0];

            return `
             <li class="wishlist-item">
                <a href="${du}">
                  <img src="${iu}" />
                  <p>${dt}</p>
                  <button type="button" class="remove-wishlist-item" data-action="remove" data-product="${handle}">Remove</button>
                </a>
             </li>
            `
        }

        async prepWishlistPage() {
            const items = await this.getWishlistPageItems();

            const gridHTML = [...items].map(this.wishlistItemHTML);

            const $grid = document.querySelector('#wishlist-item-grid');

            $grid.innerHTML = gridHTML.join('');

            const $btns = $grid.querySelectorAll('.remove-wishlist-item');

            [...$btns].forEach(($btn) => {
                $btn.addEventListener('click', (event) => {
                    const $li = event.target.closest('li');

                    this.btnClickHandler(event);

                    $li.parentElement.removeChild($li);
                });
            });

            console.log('Page Items', { items });
        } 

    }


    window.CTWF_WISHLIST = new Wishlist();

})();